import { types } from 'mobx-state-tree';

export const FavoriteTournament = types
    .model('FavoriteTournament', {
        id: types.number,
        name: types.string,
        sportId: types.maybeNull(types.number),
        categoryId: types.maybeNull(types.number),
        sportName: types.maybeNull(types.string),
        categoryName: types.maybeNull(types.string),
        order: types.maybeNull(types.number),
    })
    .actions((s) => ({

    }))
    .views((s) => ({

    }));